export default function testimonialsSliderInit($ = jQuery) {
  console.log("Testimonal slider Init");
  $(".testimonials__slider").slick({
    centerMode: true,
    centerPadding: "18%",
    slidesToShow: 1,
    arrows: false,
    adaptiveHeight: true,
    dots: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          centerPadding: "10%",
        },
      },
    ],
  });
}
